let deferredInstallPrompt = null;
const listeners = new Set();

export function onInstallAvailable(cb) {
    listeners.add(cb);
    return () => listeners.delete(cb);
}

export function getDeferredPrompt() {
    return deferredInstallPrompt;
}

window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault(); // Evita el prompt automático
    deferredInstallPrompt = e; // Guarda el evento para usarlo luego
    //   console.log(
    //       "✅ beforeinstallprompt capturado, ya puedes mostrar el botón"
    //   );

    listeners.forEach((cb) => cb()); // Notifica a la UI que ya se puede instalar
});

window.addEventListener("appinstalled", () => {
    deferredInstallPrompt = null; // Ya está instalada
});
